import { render } from "./CrispySnek.vue?vue&type=template&id=8d696cde"
import script from "./CrispySnek.vue?vue&type=script&lang=js"
export * from "./CrispySnek.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__